import type { ReactNode } from 'react';
import { Box, Skeleton, Card, CardContent, CardHeader, Typography } from '@mui/material';

interface PaymentProps {
	children?: ReactNode;
}

export const Payment = ({ children }: PaymentProps) => {
	return (
		<Card variant="outlined">
			<CardHeader title="Payment Detail" sx={{ color: 'grey.800' }} />
			<CardContent>{children}</CardContent>
		</Card>
	);
};

export const PaymentSkeleton = () => {
	return (
		<Card variant="outlined">
			<CardContent>
				<Typography variant="h6" mb={2}>
					3. Payment Details
				</Typography>
				<Box display="flex" justifyContent="space-between" mb={1}>
					<Typography variant="subtitle1">Amount Paid:</Typography>
					<Skeleton variant="text" width={140} />
				</Box>
				<Box display="flex" justifyContent="space-between" mb={1}>
					<Typography variant="subtitle1">Remaining Balance:</Typography>
					<Skeleton variant="text" width={180} />
				</Box>
			</CardContent>
		</Card>
	);
};
